import getCurrentReduxSelector from '../../../../redux/selectors/get-current'
import WORKOUTS_PATH from '../../constants/path'

const getStartedWorkoutSelect = getCurrentReduxSelector(
  WORKOUTS_PATH.DATA,
  WORKOUTS_PATH.STARTED
)

export default getStartedWorkoutSelect
